import {
  CLEAR_NEW_VISIT_SELECTED_PATIENT,
  DELETE_BOOKING,
  SET_ERROR,
  SET_IS_VISIT_RESCHEDULED_SUCCESS,
  SET_NEW_VISIT_SELECTED_PATIENT,
} from './NewVisitConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setError(value, bookingId) {
  return {
    type: SET_ERROR,
    payload: { error: value || '', bookingId },
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function deleteBooking(bookingId) {
  return {
    type: DELETE_BOOKING,
    payload: { bookingId },
  }
}

export const setIsVisitRescheduledSuccess = (value = false) => ({
  type: SET_IS_VISIT_RESCHEDULED_SUCCESS,
  payload: value,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setNewVisitSelectedPatient = (selectedPatient, bookingId) => ({
  type: SET_NEW_VISIT_SELECTED_PATIENT,
  payload: selectedPatient,
  extraData: { bookingId },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const clearNewVisitSelectedPatient = (bookingId) => ({
  type: CLEAR_NEW_VISIT_SELECTED_PATIENT,
  extraData: { bookingId },
})
